export const EpidemiologyType_Prevalence = 'prevalence';
export const EpidemiologyType_Incidence = 'incidence';
export const EpidemiologyTypes = [EpidemiologyType_Prevalence, EpidemiologyType_Incidence];
export const EpidemiologyRate_Ratio = 'ratio';
export const EpidemiologyRate_Percentage = 'percentage';
export const EpidemiologyRates = [EpidemiologyRate_Ratio, EpidemiologyRate_Percentage];
//# sourceMappingURL=types.js.map